// Life Event API configuration and helper functions
import SecureLS from 'secure-ls';

const ls = new SecureLS({ encodingType: 'aes' });

const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  ENDPOINTS: {
    LIFE_EVENTS: '/api/lifeevent/events/',
  }
};

// Helper function for API calls with authentication
const apiCall = async (endpoint, options = {}) => {
  const token = ls.get('authToken');
  
  if (!token) {
    throw new Error('Authentication token not found');
  }

  const defaultHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Token ${token}`
  };

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers
    }
  };

  try {
    const response = await fetch(`${API_CONFIG.BASE_URL}${endpoint}`, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

// Life Event API functions
export const lifeEventAPI = {
  // Create a new life event
  createEvent: (eventData) => apiCall(API_CONFIG.ENDPOINTS.LIFE_EVENTS, {
    method: 'POST',
    body: JSON.stringify(eventData)
  }),

  // Get all life events for the current user
  getEvents: () => apiCall(API_CONFIG.ENDPOINTS.LIFE_EVENTS),

  // Get a specific life event by ID
  getEvent: (eventId) => apiCall(`${API_CONFIG.ENDPOINTS.LIFE_EVENTS}${eventId}/`),

  // Update a life event
  updateEvent: (eventId, eventData) => apiCall(`${API_CONFIG.ENDPOINTS.LIFE_EVENTS}${eventId}/`, {
    method: 'PUT',
    body: JSON.stringify(eventData)
  }),

  // Delete a life event
  deleteEvent: (eventId) => apiCall(`${API_CONFIG.ENDPOINTS.LIFE_EVENTS}${eventId}/`, {
    method: 'DELETE'
  }),

  // @deprecated Use contributeMedia() from services/mediaService.js instead.
  contributeMedia: async (eventId, files) => {
    const token = ls.get('authToken');

    if (!token) {
      throw new Error('Authentication token not found');
    }

    const formData = new FormData();
    files.forEach(file => {
      formData.append('media_files', file);
    });

    const response = await fetch(
      `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.LIFE_EVENTS}${eventId}/contribute_media/`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`
          // Note: Don't set Content-Type for FormData, browser will set it with boundary
        },
        body: formData
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }
};

export default lifeEventAPI; 